App.namespace.wrap('components.history_state', ({ onChange }) => {
  const supported = (!!window.history && window.history.pushState);

  window.addEventListener('popstate', (event) => {
    if (!supported) {
      return;
    }

    onChange(event);
  });

  const pushState = (id, title, hash) => {
    if (!supported) {
      return;
    }

    history.pushState(id, title, hash);
  };

  const replaceState = (id, title) => {
    if (!supported) {
      return;
    }

    history.replaceState(id, title);
  };

  const getState = () => {
    if (!supported) {
      return null;
    }

    return history.state;
  };


  const back = () => {
    if (!supported) {
      return;
    }

    history.back();
  };

  return {
    pushState,
    replaceState,
    getState,
    back,
  };
});
